<template>
  <section style="width: 100%">
    <p-message></p-message>
    <!-- <p-message class="pc"></p-message>
    <m-message class="mobile"></m-message> -->
  </section>
</template>
<script>
// import MMessage from './mobile/MMessage'
import PMessage from './pc/PMessage'
export default {
  components: {
    // MMessage,
    PMessage,
  }
}
</script>
<style lang="less" scoped>

</style>
